import React, { useState, useEffect } from "react";
import HeadingText from "components/common/HeadingText/HeadingText";
import ButtonComponent from "components/common/Button/ButtonComponent";
import { Col, Container, Form, Row } from "reactstrap";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import {
  IAgentAssignmentPageProps,
  IAgentAssignmentPageState,
} from "interfaces/agentAssignment.interface";
import "./AgentAssignmentPage.scss";
import "react-datepicker/dist/react-datepicker.css";
import { acceptableFormats } from "config/constants";

import Toaster from "components/common/Toaster/Toaster";
import LoaderComponent from "components/common/Loader/Loader";
import UploadButtonComponent from "../../common/UploadButton/UploadButtonComponent";
import { normalizeBulkUploadPayload } from "normalizer/GlobalProductNormalizer";
import ability from "config/ability";

const AgentAssignmentPage: React.FunctionComponent<
  IAgentAssignmentPageProps
> = (props: IAgentAssignmentPageProps) => {
  const {
    isError,
    dummyFileName,
    dummyAgentAssignmentPageState,
    isLoading,
    error,
    agentChatwootAssignmentCompleted,
    agentStoreAssignmentCompleted,
    completeAgentChatwootAssignment,
    completeAgentStoreAssignment,
  } = props;

  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const [agentAssignmentPageState, setAgentAssignmentPageState] =
    useState<IAgentAssignmentPageState>(
      dummyAgentAssignmentPageState || {
        storeAssignmentCsvFile: null,
        storeAssignmentCsvFileName: dummyFileName ? dummyFileName : "",
        chatwootTaggingCsvFile: null,
        chatwootTaggingCsvFileName: dummyFileName ? dummyFileName : "",
      }
    );

  useEffect(() => {
    if (isError) {
      alert((error! as any).errors);
    }
  }, [isError, error]);

  useEffect(() => {
    if (agentStoreAssignmentCompleted) {
      handleToaster(false, "Assignment Completed");
      setAgentAssignmentPageState({
        ...agentAssignmentPageState,
        storeAssignmentCsvFile: null,
        storeAssignmentCsvFileName: "",
      });
    }
  }, [agentStoreAssignmentCompleted]);

  useEffect(() => {
    if (agentChatwootAssignmentCompleted) {
      handleToaster(false, "Assignment Completed");
      setAgentAssignmentPageState({
        ...agentAssignmentPageState,
        chatwootTaggingCsvFile: null,
        chatwootTaggingCsvFileName: "",
      });
    }
  }, [agentChatwootAssignmentCompleted]);

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });

    setTimeout(() => {
      setToaster({
        isVisible: false,
        message: message,
        isError: error,
      });
    }, 1500);
  };

  const handleCSVInputChange = (type: string, file: File) => {
    if (file) {
      if (type === "store") {
        setAgentAssignmentPageState({
          ...agentAssignmentPageState,
          storeAssignmentCsvFile: file,
          storeAssignmentCsvFileName: file.name,
        });
      } else {
        setAgentAssignmentPageState({
          ...agentAssignmentPageState,
          chatwootTaggingCsvFile: file,
          chatwootTaggingCsvFileName: file.name,
        });
      }
    }
  };

  const handleCSVRemove = (type: string, e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (type === "store") {
      setAgentAssignmentPageState({
        ...agentAssignmentPageState,
        storeAssignmentCsvFile: null,
        storeAssignmentCsvFileName: "",
      });
    } else {
      setAgentAssignmentPageState({
        ...agentAssignmentPageState,
        chatwootTaggingCsvFile: null,
        chatwootTaggingCsvFileName: "",
      });
    }
  };
  //need to write test for this too
  const handleSubmit = () => {
    const { chatwootTaggingCsvFile, storeAssignmentCsvFile } =
      agentAssignmentPageState;
    if (chatwootTaggingCsvFile) {
      const normalizedPayload = normalizeBulkUploadPayload(
        chatwootTaggingCsvFile
      );
      completeAgentChatwootAssignment(normalizedPayload);
    }
    if (storeAssignmentCsvFile) {
      const normalizedPayload = normalizeBulkUploadPayload(
        storeAssignmentCsvFile
      );
      completeAgentStoreAssignment(normalizedPayload);
    }
  };

  const {
    chatwootTaggingCsvFile,
    storeAssignmentCsvFile,
    storeAssignmentCsvFileName,
    chatwootTaggingCsvFileName,
  } = agentAssignmentPageState;

  
  const renderFormButton = () => {
    return (
      <Row className="mt-5">
        <Col lg="6">
          <div id="handle-submit-container">
            <ButtonComponent
              buttonClass="large-button btn-primary handle-submit"
              buttonText={"Upload"}
              onClickHandler={handleSubmit}
              isDisable={
                isLoading ||
                  (storeAssignmentCsvFile === null &&
                  chatwootTaggingCsvFile === null)
              }
            />
          </div>
        </Col>
      </Row>
    );
  };

  const storeAssignmentCSVForm = () => {
    return (
      <FormSectionLayout subTitleText="Store Assignment">
        <section
          className="form-group search-container"
          id="store-assignment-container"
        >
          <div className="agentAssignment--csv-container">
            <UploadButtonComponent
              id="upload-storeAssignment-csv"
              buttonText={
                storeAssignmentCsvFileName ? "" : "Upload .csv for assignment"
              }
              fileFormat={acceptableFormats.csv}
              fileUploaded={!!storeAssignmentCsvFileName}
              handleRemoveFile={(e) => handleCSVRemove("store", e)}
              handleFileChange={(f) => handleCSVInputChange("store", f)}
              classes="large-button"
            />
            <label className="liveops--csv-container-filename">
              {storeAssignmentCsvFileName}
            </label>
            <a
              href={require("../../../assets/static/Agent-StoreAssignment-Sample.csv")}
              target="_blank"
              className="agentAssignment--csv-container-downloadsample"
            >
              Download Sample
            </a>
          </div>
        </section>
      </FormSectionLayout>
    );
  };

  const chatwootAssignmentCSVForm = () => {
    return (
      <FormSectionLayout subTitleText="Chatwoot Assignment">
        <section
          className="form-group search-container"
          id="chatwoot-assignment-container"
        >
          <div className="agentAssignment--csv-container">
            <UploadButtonComponent
              id="upload-chatwootAssignment-csv"
              buttonText={
                chatwootTaggingCsvFileName ? "" : "Upload .csv for assignment"
              }
              fileFormat={acceptableFormats.csv}
              fileUploaded={!!chatwootTaggingCsvFileName}
              handleRemoveFile={(e) => handleCSVRemove("chatwoot", e)}
              handleFileChange={(f) => handleCSVInputChange("chatwoot", f)}
              classes="large-button"
            />
            <label className="liveops--csv-container-filename">
              {chatwootTaggingCsvFileName}
            </label>
            <a
              href={require("../../../assets/static/Agent-ChatwootAssignment-Sample.csv")}
              target="_blank"
              className="agentAssignment--csv-container-downloadsample"
            >
              Download Sample
            </a>
          </div>
          {/* {renderFormButton()} */}
        </section>
      </FormSectionLayout>
    );
  };

  return (
    <Container fluid className="assignment--container">
      {isLoading && <LoaderComponent />}
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <Row>
        <Col lg="5">
          <div className="agentAssignment--main-heading">
            <HeadingText text={"Assignment"} isMainHeading={true} />
          </div>
        </Col>
      </Row>

      <Row className="form-container ml-0 mr-0">
        <Col xs="12">
          <Form>
            <Row className="form-container">
              {ability.can("read", "product") && storeAssignmentCSVForm()}    
              {ability.can("create", "criteria") && chatwootAssignmentCSVForm()}
              {/* <div className="form-group search-container"> */}
              {renderFormButton()}
              {/* </div> */}
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default AgentAssignmentPage;
